import { render } from "./AppLogo.vue?vue&type=template&id=eb71717c"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__